<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path d="M1483.11,537.71c0-284.5-229.23-515.13-512-515.13s-512,230.63-512,515.13c0,257.11,187.23,470.23,432,508.87v-360h-130V537.71h130V424.22c0-129.1,76.44-200.41,193.39-200.41,56,0,114.61,10.06,114.61,10.06V360.64h-64.56c-63.6,0-83.44,39.71-83.44,80.49v96.58h142l-22.7,148.91h-119.3v360C1295.88,1007.94,1483.11,794.82,1483.11,537.71Z" transform="translate(-459.11 -22.58)" style="fill:#1877f2"/></svg>
</template>

<script>
    export default {
        name: "FacebookSVG",
    }
</script>